import './styles.scss';
import React, {useRef} from 'react';

import Description from '../../Description';
import Header from '../../Header';
import Sessions from '../../Sessions';
import Video from '../../Video';
import Chat from '../../Chat';
import EventService from '../../../services/EventService';
import ResponsiveService from '../../../services/ResponsiveService';

export const JoinedLayout = ({attrs}) => {

    ResponsiveService.ref = useRef();
    const chatIsEnabled   = EventService.chatIsEnabled(attrs.event);
    const layoutClasses   = [
        'stream-page-layout-joined', 
        chatIsEnabled ? 'chat-is-enabled' : 'chat-is-disabled'
    ];

	return (
        <div ref={ResponsiveService.ref} className={layoutClasses.join(' ')}>
            <Header {...attrs}  />
            <div className="inner-wrapper d-flex">
                <div className="wrapper-left">
                    <div className="row no-gutters">
                        <Video {...attrs} />
                    </div>
                    <div className="row no-gutters">
                        <Description {...attrs}  /> 
                        <Sessions {...attrs} />
                    </div>
                </div>
                {chatIsEnabled ? (
                    <div className="wrapper-right">
                        <Chat {...attrs} />
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default JoinedLayout;